import { useQuery } from '@tanstack/react-query';

import { getCourses } from 'api';
import { AxiosRequestConfig } from 'axios';

/**
 * A custom hook to fetch all courses from the CoreService.
 *
 * @returns DefinedUseQueryResult<Course[], Error>
 */
export const useCoursesQuery = (config?: AxiosRequestConfig) => {
  const query = useQuery({
    queryKey: ['courses', config ? JSON.stringify(config.params) : ''],
    queryFn: () => {
      const courses = getCourses(config);
      return courses;
    },
    initialData: [] // Should be removed but has to be refactored in many places
    // staleTime: 1000 * 60 * 5 // 5 minutes
  });
  return query;
};
